export function isAssistantEnabled(site) {
  return site?.assistantEnabled === true || site?.beta?.assistant === true;
}

export function isScoutChatEnabled(site) {
  return site?.beta?.scoutChat === true;
}

export function hasMissingAssistantTariff(site) {
  const schedule = Array.isArray(site?.energyPlan?.schedule) ? site.energyPlan.schedule : [];
  return site?.beta?.assistant === true && !schedule.some((window) => window && window.active !== false);
}
